// Facts that the honest-build public pages are allowed to state.
// Legal entity name, address, and VAT ID stay in legalController.js.

export const SUPPORT_EMAIL = "support@ouro.is";

export const STEAM_IS_ENOUGH =
  "A Steam account is all you need to join. Everything else builds your reputation on the platform.";

export const KYC_OPTIONAL =
  "ID verification is optional. If you do it, it runs through didit.me and adds to your reputation. It is not required to sign up or play.";
